import api from '../../api';

const path = '/parts';

export const addPartsRequest = (values) => api.post(`${path}/add`, values);
export const editPartsRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const getPartsRequest = (id) => api.get(`${path}/get/${id}`);
export const getPartsListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const deletePartsRequest = (id) => api.delete(`${path}/delete/${id}`);
export const updatePartsRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);
